import { Box, Chip, Paper, Table as MuiTable, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { currency } from "../../utils/formatters";

export default function Table({ rows = [], mode = "clear_now" }) {
  const getCashCellStyles = () => {
    return mode === "clear_now"
      ? {
          color: "#b42318",
          fontWeight: 700,
        }
      : {
          color: "#b54708",
          fontWeight: 700,
        };
  };

  const getSecondaryBadge = (item) => {
    if (mode === "clear_now") {
      return (
        <Chip
          label={item.recommended_discount_band || "—"}
          size="small"
          sx={{
            fontWeight: 600,
            bgcolor: "#fff7ed",
            color: "#9a3412",
            border: "1px solid #fed7aa",
            borderRadius: "8px",
          }}
        />
      );
    }

    return (
      <Chip
        label={
          item.predicted_dead_in_days != null
            ? `${item.predicted_dead_in_days} days`
            : "—"
        }
        size="small"
        sx={{
          fontWeight: 600,
          bgcolor: "#fffbeb",
          color: "#92400e",
          border: "1px solid #fde68a",
          borderRadius: "8px",
        }}
      />
    );
  };

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        border: "1px solid #e5e7eb",
        borderRadius: 1,
        overflow: "hidden",
        backgroundColor: "#ffffff",
      }}
    >
      <MuiTable sx={{ minWidth: 1000 }}>
        <TableHead>
          <TableRow
            sx={{
              backgroundColor: "#f8fafc",
              "& .MuiTableCell-root": {
                borderBottom: "1px solid #e5e7eb",
                color: "#475467",
                fontSize: "13px",
                fontWeight: 700,
                py: 1.75,
                whiteSpace: "nowrap",
              },
            }}
          >
            <TableCell>SKU</TableCell>
            <TableCell>Product</TableCell>
            <TableCell>Category</TableCell>
            <TableCell align="center">Inventory</TableCell>
            <TableCell align="center">Last Sale Gap</TableCell>
            <TableCell align="right">
              {mode === "clear_now" ? "Dead Cash" : "At Risk Cash"}
            </TableCell>
            <TableCell align="center">
              {mode === "clear_now" ? "Discount" : "Dead In"}
            </TableCell>
            <TableCell>Reason</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((item, index) => (
            <TableRow
              key={item.sku_code}
              hover
              sx={{
                "& .MuiTableCell-root": {
                  borderBottom: "1px solid #f1f5f9",
                  py: 1.8,
                  fontSize: "14px",
                  color: "#344054",
                },
                "&:last-child .MuiTableCell-root": {
                  borderBottom: "none",
                },
                "&:hover": {
                  backgroundColor: "#f9fafb",
                },
              }}
            >
              <TableCell>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 700,
                    color: "#111827",
                    letterSpacing: 0.2,
                  }}
                >
                  {item.sku_code}
                </Typography>
              </TableCell>

              <TableCell>
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: "#101828",
                    mb: 0.25,
                  }}
                >
                  {item.product_name}
                </Typography>
                <Typography variant="body2" sx={{ color: "#667085" }}>
                  {item.brand || "—"}
                </Typography>
              </TableCell>

              <TableCell>
                <Chip
                  label={item.category || "—"}
                  size="small"
                  sx={{
                    bgcolor: "#f2f4f7",
                    color: "#344054",
                    fontWeight: 600,
                    borderRadius: "8px",
                  }}
                />
              </TableCell>

              <TableCell align="center">
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: "#111827",
                  }}
                >
                  {item.inventory_units ?? 0}
                </Typography>
              </TableCell>

              <TableCell align="center">
                <Typography
                  sx={{
                    fontWeight: 600,
                    color:
                      item.days_since_last_sale >= 60
                        ? "#b42318"
                        : item.days_since_last_sale >= 30
                        ? "#b54708"
                        : "#344054",
                  }}
                >
                  {item.days_since_last_sale != null
                    ? `${item.days_since_last_sale} days`
                    : "—"}
                </Typography>
              </TableCell>

              <TableCell align="right">
                <Typography sx={getCashCellStyles()}>
                  {currency(
                    item.stuck_cash
                  )}
                </Typography>
              </TableCell>

              <TableCell align="center">{getSecondaryBadge(item)}</TableCell>

              <TableCell>
                <Box
                  sx={{
                    maxWidth: 280,
                    px: 1.25,
                    py: 0.75,
                    borderRadius: 2,
                    bgcolor: "#f8fafc",
                    border: "1px solid #eaecf0",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#475467",
                      lineHeight: 1.4,
                    }}
                  >
                    {item.reason || "—"}
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          ))}

          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={8} align="center" sx={{ py: 6 }}>
                <Typography sx={{ fontWeight: 600, color: "#344054", mb: 0.5 }}>
                  No action items found
                </Typography>
                <Typography variant="body2" sx={{ color: "#667085" }}>
                  Items that need attention will appear here.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
}